'use strict';
import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { ActivityType } from 'owa-activity-feed';
import { setActivityFeedEnabledInApp } from '../actions/setActivityFeedEnabledInApp';

mutator(setActivityFeedEnabledInApp, actionMessage => {
    const { activityTypeIsEnabled } = actionMessage;
    if (getStore().disabledInFeedPanel == null) {
        getStore().disabledInFeedPanel = [];
    }
    Object.keys(activityTypeIsEnabled).forEach(activityType => {
        const enabled = activityTypeIsEnabled[activityType];
        if (!enabled && getStore().disabledInFeedPanel.indexOf(ActivityType[activityType]) == -1) {
            getStore().disabledInFeedPanel = getStore().disabledInFeedPanel.concat([
                ActivityType[activityType],
            ]);
        } else if (enabled) {
            getStore().disabledInFeedPanel = getStore().disabledInFeedPanel.filter(
                disabledType => disabledType != activityType
            );
        }
    });
});
